import { Component } from '@angular/core';
 
@Component({
  selector: 'tap-reveal',
  templateUrl: 'tap-reveal.html'
})
export class TapRevealComponent {
 
  toggled: boolean = false;
 
  constructor() {
 
  }
 
  toggle() {
    this.toggled = !this.toggled;
  }
 
}




// WEBPACK FOOTER //
// ./src/components/tap-reveal/tap-reveal.ts